import * as yup from "yup";

export const entrySchema = yup.object().shape({
        title: yup.string()
        .required("Title is required")
        .max(100, "Title can't be more than 100 characters"),
        data: yup.string()
        .required("Data is required")
        .max(1000, "Data can't exceed 1000 characters")
})